<template>
  <div></div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
export default {
  name: 'volume-set-unmanage',
  methods: {
    openConfirm (id, status) {
      detailPrivateCloudVolume(id).then(res => {
        if (status === 'available') {
          this.$Modal.confirm({
            title: '设为非管理卷',
            content: '确认把此卷「' + res.data.volume.name + '」设为非管理卷吗？完成设置后，该卷将不再可视。请注意，这个卷不会从cinder主机中删除！',
            onOk: () => {
              this.submit(id)
            }
          })
        } else {
          this.$Notice.error({
            title: '只有该卷为可用状态时才允许执行此操作！'
          })
        }
      })
    },
    submit (id) {
      let reqData = {
        'os-unmanage': {}
      }
      actionPrivateCloudVolume(reqData, id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
        this.$emit('callback')
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
